import React, { Component } from "react";
import styles from "./Authorizations.local.scss";
import classnames from "classnames";

export default class UserFetching extends Component {
  getUserFetching() {
    let usersFetching = [];
    for (let i = 0; i < 8; i++) {
      usersFetching.push(
        <div
          key={i}
          className={classnames(
            styles.user,
            styles.user_fetching,
            "column small-12 medium-6 large-4"
          )}
        >
          <div className={styles.user_container} />
          <div className={classnames(styles.user_avatar, styles.gradiant)} />
          <h3 className={styles.gradiant}> </h3>
          <h4 className={classnames(styles.separator, styles.gradiant)}> </h4>
          <h5 className={styles.gradiant}> </h5>
        </div>
      );
    }
    return usersFetching;
  }

  render() {
    return <div className="small-11 row">{this.getUserFetching()}</div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/Authorizations/UserFetching.js